module.exports = __webpack_public_path__ + "static/media/oci-training.96ce39ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oci-training.png
// module id = 513
// module chunks = 0